module.exports = __webpack_public_path__ + "media/images/icons/filled/yuque-dbe2d69748143455a16dfd835b058d25.svg";